import { runIfExist } from './common.js';
export function runCallback(fn, ...args) {
    fn(...args);
}
export function returnCallback(fn, ...args) {
    return runIfExist(fn, ...args);
}
export function returnSelf(value) {
    return value;
}
//# sourceMappingURL=run-callback.js.map